module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#comment",
      toString: function () {
        return this.url;
      }
    }